import _WidgetBaseSP from 'more/_WidgetBaseSP';

import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MonthColumnPlanMonthPicker.html?raw';

import Multiselect from '../../../moreCore/UI/Multiselect/Multiselect';
import "../../../moreCore/UI/Multiselect/Multiselect";

class MonthColumnPlanMonthPicker extends compose(_WidgetBaseSP) {
    templateString: any = template;

    startDate: Date = null;
    currentSelectedDate: Date = null;
    datePickerWidgetContainer: HTMLDivElement;


    pickerWidget: MdsLax<InstanceType<typeof Multiselect>>;

    private year_spread_backwards = 2; //wie viele jahre vor/zurueck angezeigt werden zur auswahl
    private year_spread_forward = 3;

    private selectedValues: Array<{y:number, m:number}> = [];

    constructor(startDate: Date) {
        super(...(arguments as unknown as []));
        if ((startDate != null) || (typeof startDate != 'undefined')) {
            this.startDate = startDate;
        }
    }

    public getSelectedValues(){
        return this.selectedValues;
    }

    public setSingleSelect(b:boolean){
        this.pickerWidget.setMultiselect(!b);
    }

    public setSelectedDate(y:number, m:number){
        let tmp = new Date(y,m,1);
        this.pickerWidget.setValue(tmp);
    }

    private getLocalMonthStrings(y: number): Array<{ monthPrintname: string; monthNumber: number; yearNumber: number; dateObj: Date }> { //generiert eine liste von monats-namen nach gesetzten locals
        let d = new Date(y,0,1);
        let res: Array<{ monthPrintname: string; monthNumber: number; yearNumber: number; dateObj: Date }> = [];
        for (let i = 0; i <= 11; i++) {
            d.setMonth(i);
            let monthNameStr = d.toLocaleString(window.currentLanguageCode2, { month: 'long' });
            res.push({
                monthPrintname: monthNameStr,
                monthNumber: i,
                yearNumber: d.getFullYear(),
                dateObj: new Date(d.getFullYear(), i, 1),
            });
        }
        return res;
    }

    private groupIconCss: Array<string> = [];
    private groupIconName: Array<string> = [];
    private generateMultiselectOptions(){
        let res:Array<any> = [];
        let startYear = this.startDate.getFullYear();
        let iconCssClassList = [];
        let iconNameList = [];
        for (let y = (startYear-this.year_spread_backwards);y<=(startYear+this.year_spread_forward);y++){
            for (let cMY of this.getLocalMonthStrings(y)){
                res.push({
                    value: cMY.dateObj,
                    label: cMY.yearNumber +"   -   "+cMY.monthPrintname,
                    groupByName: String(y),
                    groupByValue: String(y),
                });
                iconNameList.push(String(y));
                iconCssClassList.push("far fa-calendar-alt");
            }
        }
        this.groupIconCss = iconCssClassList;
        this.groupIconName = iconNameList
        return res;
    }

    private _onHandle_PickerChanged(selectedValues:Array<string>){
        this.selectedValues = [];
        for (let val of selectedValues){
            let tmp = new Date(val);
            this.selectedValues.push({
                y: tmp.getFullYear(),
                m: tmp.getMonth(),
            });
        }
    }

    private async loadConfig(){
        //year range
        let res:Promise<object> = new Promise((resolve, reject)=>{
            this.RequestManager.callfunction(
                "MonthColumnPlan_API__MontSelectGetYearRange",
                {},
                (res)=>{
                    resolve(res);
                },
                (err)=>{
                    console.error(err);
                    reject(err);
                }
            );
        });

        let result:object;
        try{
            result = await res;
        }catch{
            let msg: string = result["Message"];
            if (typeof result == 'string'){
                msg = result as string;
            }
            //eigentlich is es wurscht
            //this.showToast(msg, "fas fa-exclamation-circle");
            return;
        }

        let yearRangeStr = "2;3";

        if (typeof result["yearRangeStr"] == 'string'){
            let resStr: string = result["yearRangeStr"];
            const regex = /^\d+;\d+$/;
            if (regex.test(resStr)){
                yearRangeStr = resStr;
            }
        }

        let forward = parseInt(yearRangeStr.split(";")[0] ?? "2");
        let backward = parseInt(yearRangeStr.split(";")[1] ?? "3" );
        this.year_spread_backwards = forward;
        this.year_spread_forward = backward;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.init();
    }

    private async init(){
        this.StandbyStart();
        await this.loadConfig();
        this.StandbyStop();

        this.pickerWidget = new Multiselect();
        this.pickerWidget.setCyName("MonthColumnPlanMonthPicker");

        let startDate = new Date();
        if ((this.startDate != null) && (typeof this.startDate != 'undefined')) {
            startDate = this.startDate;
        } else {
            this.startDate = startDate; //wir setzten das start date selber wenn es keines gibt
        }
        let todayMonth = startDate.toLocaleString(window.currentLanguageCode2, { month: 'long' });
        this.pickerWidget.setPlaceholderValue(todayMonth);
        this.pickerWidget.currentSelect = [];
        this.pickerWidget.setData(null, this.generateMultiselectOptions(), true, "label", "value", null, "groupByName", "groupByValue", null);
        this.pickerWidget.setGroupIcons(this.groupIconName, this.groupIconCss);
        this.pickerWidget.placeAt(this.datePickerWidgetContainer);
        this.pickerWidget.on("valueChange", lang.hitch(this, this._onHandle_PickerChanged));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MonthColumnPlanMonthPicker);
